import React from "react"; 
import { HiOutlineViewList } from 'react-icons/hi'; 
import './style.css'; 


let CruxAllignment=(props)=> { 
  
  return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc">
        <h4 id="h4">
  CRUX - Aligment ScoreCard
  </h4>
        <br></br>
        <h6 id="h6">
  CRUX -Alignemnt scorecard evaluates strength of alignment amognst problem, root causes, solution and business goals</h6>
        <div id='divL'>
          <table id='tableAll'>
            <thead>
              <tr>
                <th scope="col">Question</th>
                <th scope="col">Rating</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-label="Question">Are you able to identify all root caused For the problem or you need</td>
                <td data-label="Rating">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">All Rooted Causes Identified</option>
                    <option value="2">Some of the Root cause Identified</option>
                    <option value="3">No Root Causess could be Identified</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Question">Are you Able to identify solion differentiators that have significant impact on root cause elimination?</td>
                <td data-label="Rating">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Yes</option>
                    <option value="2">Somewhat </option>
                    <option value="3">No</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Question">Are there any frequent root causes that are not solvable?</td>
                <td data-label="Rating">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Yes</option>
                    <option value="3">No</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Question">What is Crux Competative Score?</td>
                <td data-label="Rating">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">More Then 30% of Winner and No lossing</option>
                    <option value="2">Differentiator</option>
                    <option value="3">Something Different</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Question">Are you able to clearify identify how a sucessfull product will help your business?</td>
                <td data-label="Rating">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Yes</option>
                    <option value="2">Somewhat </option>
                    <option value="3">No</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Question">Is There Consious Amongest stakeholder on product business goal allignment?</td>
                <td data-label="Rating">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">Yes</option>
                    <option value="2">Somewhat </option>
                    <option value="3">No</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Question">Total</td>
                <td data-label="Rating">
                  <input type='text' placeholder="Locked" style={{padding:4,marginTop:10,borderRadius:4,borderColor: 'transparent',outline: 'none',color: '#666B6E',width:200,height:45}}></input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="flexLef">
          <button className="button2" onClick={()=>props.history.push('/problemValidation')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/cruxImpact')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>) } 
  
  
  export default CruxAllignment;